var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"active-vehicles"},[_c('active-vehicles')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('h3',{staticClass:"title-content"},[_vm._v("Veículos Ativos")])])
}]

export { render, staticRenderFns }